import { render, staticRenderFns } from "./DataBankModel.vue?vue&type=template&id=f4d8da78&scoped=true&"
import script from "./DataBankModel.vue?vue&type=script&lang=js&"
export * from "./DataBankModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d8da78",
  null
  
)

export default component.exports